import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=bb96fd5e&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=bb96fd5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb96fd5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb96fd5e')) {
      api.createRecord('bb96fd5e', component.options)
    } else {
      api.reload('bb96fd5e', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=bb96fd5e&scoped=true&", function () {
      api.rerender('bb96fd5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sq3CvAhtDUsr/JS/comp/DocBox.vue"
export default component.exports